export default __webpack_public_path__ + "static/media/c001-E-commerce-4.0935912d.jpg";